import { track } from './core';

export function trackReportDownloadPdfClicked(appId, appName) {
  track('report_download_pdf_clicked', { app_id: appId, app_name: appName });
}

export function trackReportLinkCopied(appId, appName) {
  track('report_link_copied', { app_id: appId, app_name: appName });
}

export function trackReportDeleted(appId, appName) {
  track('report_deleted', { app_id: appId, app_name: appName });
}

export function trackReportTabSwitched(appId, appName, tab) {
  track('report_tab_switched', { app_id: appId, app_name: appName, tab });
}

export function trackReportFolderNavClicked(appId, appName, folder) {
  track('report_folder_nav_clicked', { app_id: appId, app_name: appName, folder });
}

export function trackReportVulnGotoClicked(appId, appName) {
  track('report_vuln_goto_clicked', { app_id: appId, app_name: appName });
}

export function trackReportSidebarToggled(appId, appName) {
  track('report_sidebar_toggled', { app_id: appId, app_name: appName });
}

export function trackReportVulnDescriptionClicked(appId, appName) {
  track('report_vuln_description_clicked', { app_id: appId, app_name: appName });
}

export function trackReportComplianceViewed(appId, appName, requirementName) {
  track('report_compliance_viewed', { app_id: appId, app_name: appName, requirement: requirementName });
}
